"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
exports.BASE_CLASS_NAME = constants_1.BASE_CLASS_NAME + "-group";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/list/lib/Group/constants.js
// module id = ./node_modules/@react-mdc/list/lib/Group/constants.js
// module chunks = 1